    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" *ngIf="isCreate">Yeni Müşteri</h4>
      <h4 class="modal-title" id="modal-basic-title" *ngIf="!isCreate">Müşteriyi Güncelle</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="mb-3 col">
                <label class="d-block">Müşteri Tipi</label>
                <div class="btn-group w-100" role="group" aria-label="Müşteri Tipi">
                    <ng-container *ngFor="let option of customerTypeOptions">
                        <input type="radio" class="btn-check" name="customerType" [id]="'customerType' + option.value"
                            [checked]="request.customerType === option.value" (change)="onCustomerTypeChange(option.value)">
                        <label class="btn btn-outline-primary" [for]="'customerType' + option.value">
                            <i class="fas me-1" [ngClass]="option.value === CustomerType.Company ? 'fa-building' : 'fa-user'"></i>
                            {{ option.label }}
                        </label>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="mb-3 col">
                <label for="name">{{ isCompany ? 'Ünvan' : 'Ad Soyad' }} <span class="text-danger" ngbTooltip="Zorunlu alan">*</span> </label>
                <div class="input-group">
                    <input type="text" id="name"  class="form-control" [(ngModel)]="request.name" [placeholder]="isCompany ? 'Ünvan' : 'Ad Soyad'">
                </div>
            </div>
        </div>
        <div class="row">
          <div class="mb-3 col">
            <label for="displayName">Görünür Adı <span class="text-danger" ngbTooltip="Zorunlu alan">*</span></label>
            <div class="input-group">
                <input type="text" id="displayName"class="form-control" [(ngModel)]="request.displayName" placeholder="Kısa Adı">
            </div>
        </div>
        </div>

        <div class="row" *ngIf="isCompany">
            <div class="mb-3 col-md-6">
                <label for="taxAdministration">Vergi Dairesi </label>
                <div class="input-group">
                    <input type="text" id="taxAdministration" class="form-control" [(ngModel)]="request.taxAdministration" placeholder="Vergi Dairesi">
                </div>
            </div>

            <div class="mb-3 col-md-6">
                <label for="taxNumber"><i class="fa fa-info-circle text-info" ngbTooltip="10 haneli Vergi Kimlik Numarası"></i> Vergi Numarası </label> 
                <div class="input-group">
                    <input type="text" id="taxNumber" class="form-control" maxlength="10" [(ngModel)]="request.taxNumber" placeholder="Vergi Numarası">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-md-6" *ngIf="!isCompany">
                <label for="tckn"><i class="fa fa-info-circle text-info" ngbTooltip="11 haneli T.C. kimlik numarası"> </i> TCKN</label>
                <div class="input-group">
                    <input type="text" id="tckn" class="form-control" maxlength="11" [(ngModel)]="request.tckn" placeholder="TCKN">
                </div>
            </div>

            <div class="mb-3 col-md-6">
                <label for="email">E-Posta </label>
                <div class="input-group">
                    <input type="email" id="email" class="form-control" [(ngModel)]="request.email" placeholder="E-Posta">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="phone">Telefon </label>
                <div class="input-group">
                    <input type="text" id="phone" class="form-control" [(ngModel)]="request.phone" placeholder="Telefon">
                </div>
            </div>
            <div class="mb-3 col-md-6">
                <label for="landPhone">Sabit Telefon </label>
                <div class="input-group">
                    <input type="text" id="landPhone" class="form-control" [(ngModel)]="request.landPhone" placeholder="Sabit Telefon">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="city">İl </label>
                <div class="input-group">
                    <input type="text" id="city" class="form-control" [(ngModel)]="request.city" placeholder="İl">
                </div>
            </div>
            <div class="mb-3 col-md-6">
                <label for="district">İlçe </label>
                <div class="input-group">
                    <input type="text" id="district" class="form-control" [(ngModel)]="request.district" placeholder="İlçe">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-md-9">
                <label for="shortAddress">Adres </label>
                <div class="input-group">
                    <input type="text" id="shortAddress" class="form-control" [(ngModel)]="request.shortAddress" placeholder="Adres">
                </div>
            </div>
            <div class="mb-3 col-md-3">
                <label for="postalCode">Posta Kodu </label>
                <div class="input-group">
                    <input type="text" id="postalCode" class="form-control" [(ngModel)]="request.postalCode"
                        placeholder="20000" maxlength="5" inputmode="numeric" pattern="[0-9]{5}">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="debtLimit" triggers="hover" ngbTooltip="Has cinsinden">İşlem Limiti</label>
                <div class="input-group">
                    <input type="number" id="debtLimit" class="form-control" [(ngModel)]="request.debtLimit" placeholder="İşlem Limiti">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col">
                <label for="description">Açıklama </label>
                <div class="input-group">
                    <textarea id="description" class="form-control" [(ngModel)]="request.description" placeholder="Açıklama"></textarea>
                </div>
            </div>
        </div>

        <div class="row ps-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [(ngModel)]="request.isActive" id="isActive">
            <label class="form-check-label" for="isActive">
              Aktif mi?
            </label>
          </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="onSubmit()">Kaydet</button>
        <button type="button" class="btn btn-secondary" [disabled]="isDisabled" (click)="activeModal.close('Save click')">Geri Dön</button>
    </div>
